<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_proposal"
            role="tab"
          >
            <h6><span class="far fa-users"></span> Dados do cliente</h6>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="proposalId > 0">
          <a
            class="nav-link m-tabs__link"
            data-toggle="tab"
            href="#save_proposal_sevice"
            role="tab"
          >
            <h6><span class="far fa-history"></span> Proposta</h6>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="proposalId > 0">
          <a
            class="nav-link m-tabs__link"
            data-toggle="tab"
            href="#customer_group_history"
            role="tab"
          >
            <h6><span class="far fa-history"></span> Histórico</h6>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_proposal" role="tabpanel">
          <ProposalsSaveForm :proposal="data" @savedProposal="savedProposal" />
        </div>
        <div class="tab-pane" id="save_proposal_sevice" role="tabpanel">
          <ProposalServices :proposal="data" @savedProposal="savedProposal" />
        </div>
        <div class="tab-pane" id="customer_group_history" role="tabpanel">
          <ProposalHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProposalsSaveForm from '@/components/customers/proposals/CustomerProposalSaveForm';
import ProposalServices from '@/components/customers/proposals/CustomerProposalService';
import ProposalHistory from '@/components/customers/proposals/CustomerProposalHistory';
import axios from 'axios';

import { baseApiUrl } from '@/global';

export default {
  name: 'ProposalsModal',
  data() {
    return {
      data: {},
      change_reason: null,
    };
  },
  components: {
    ProposalsSaveForm,
    ProposalServices,
    ProposalHistory,
  },
  methods: {
    savedProposal(data) {
      this.data = data;
      this.$store.state.showProposalSave = data.id;
    },
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showProposalSave = null;
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/proposal/data/${this.proposalId}`;
      axios(url).then((res) => {
        if (res.data) {
          this.data = res.data;
        }
      });
    },
  },
  computed: {
    proposalId() {
      return this.$store.state.showProposalSave;
    },
  },
  beforeMount() {
    this.getDatas();
  },
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
